"use client";

import { c as _c } from "react/compiler-runtime";
import Image from "next/image";
import { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { useEnsName, useReadContract } from "wagmi";
import { NextGenCollection } from "@/entities/INextgen";
import DotLoader from "@/components/dotLoader/DotLoader";
import { NEXTGEN_CHAIN_ID, NEXTGEN_CORE } from "../nextgen_contracts";
import styles from "./NextGen.module.scss";
import { faExternalLinkSquare } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Link from "next/link";
import { Tooltip } from "react-tooltip";
import { mainnet } from "viem/chains";
import { areEqualAddresses } from "@/helpers/Helpers";
import useCapacitor from "@/hooks/useCapacitor";
import { useIdentity } from "@/hooks/useIdentity";
import Address from "@/components/address/Address";
import { useSeizeConnectContext } from "@/components/auth/SeizeConnectContext";
import { useCookieConsent } from "@/components/cookies/CookieConsentContext";
import { formatNameForUrl, getOpenseaLink } from "../nextgen_helpers";
interface Props {
  collection: NextGenCollection;
  token_id: number;
}
export default function NextGenTokenOnChain(props) {
  const $ = _c(38);
  const capacitor = useCapacitor();
  const {
    country
  } = useCookieConsent();
  const account = useSeizeConnectContext();
  const [owner, setOwner] = useState();
  const [ownerENS, setOwnerENS] = useState();
  const [fetchingMetadata, setFetchingMetadata] = useState(true);
  const [tokenNotFound, setTokenNotFound] = useState(false);
  const [tokenMetadataUrl, setTokenMetadataUrl] = useState("");
  const [tokenImage, setTokenImage] = useState("");
  const normalisedTokenId = props.token_id - props.collection.id * 10000000000;
  const tokenName = `${props.collection.name} #${normalisedTokenId}`;
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      refetchInterval: 10000
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props.token_id) {
    t1 = {
      address: NEXTGEN_CORE[NEXTGEN_CHAIN_ID] as `0x${string}`,
      abi: NEXTGEN_CORE.abi,
      chainId: NEXTGEN_CHAIN_ID,
      functionName: "tokenURI",
      query: t0,
      args: [props.token_id]
    };
    $[1] = props.token_id;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const tokenUriRead = useReadContract(t1);
  let t2;
  let t3;
  if ($[3] !== tokenUriRead.data) {
    t2 = () => {
      const data = tokenUriRead.data;
      if (data) {
        const tokenUri = data as string;
        setTokenMetadataUrl(tokenUri);
        fetch(tokenUri).then(meta => {
          meta.json().then(metaJson => {
            setTokenImage(metaJson.image);
          });
        });
      } else {
        setTokenNotFound(true);
      }
      setFetchingMetadata(false);
    };
    t3 = [tokenUriRead.data];
    $[3] = tokenUriRead.data;
    $[4] = t2;
    $[5] = t3;
  } else {
    t2 = $[4];
    t3 = $[5];
  }
  useEffect(t2, t3);
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      refetchInterval: 10000
    };
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== props.token_id) {
    t5 = {
      address: NEXTGEN_CORE[NEXTGEN_CHAIN_ID] as `0x${string}`,
      abi: NEXTGEN_CORE.abi,
      chainId: NEXTGEN_CHAIN_ID,
      functionName: "ownerOf",
      query: t4,
      args: [props.token_id]
    };
    $[7] = props.token_id;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const ownerRead = useReadContract(t5);
  let t6;
  let t7;
  if ($[9] !== ownerRead.data) {
    t6 = () => {
      const data_0 = ownerRead.data as any;
      if (data_0) {
        setOwner(data_0);
      }
    };
    t7 = [ownerRead.data];
    $[9] = ownerRead.data;
    $[10] = t6;
    $[11] = t7;
  } else {
    t6 = $[10];
    t7 = $[11];
  }
  useEffect(t6, t7);
  let t8;
  if ($[12] !== owner) {
    t8 = {
      address: owner,
      chainId: mainnet.id
    };
    $[12] = owner;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  const ownerENSRead = useEnsName(t8);
  let t10;
  let t9;
  if ($[14] !== ownerENSRead.data) {
    t9 = () => {
      const data_1 = ownerENSRead.data;
      if (data_1) {
        setOwnerENS(data_1);
      }
    };
    t10 = [ownerENSRead.data];
    $[14] = ownerENSRead.data;
    $[15] = t10;
    $[16] = t9;
  } else {
    t10 = $[15];
    t9 = $[16];
  }
  useEffect(t9, t10);
  let t11;
  if ($[17] !== owner) {
    t11 = {
      handleOrWallet: owner,
      initialProfile: null
    };
    $[17] = owner;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  const {
    profile
  } = useIdentity(t11);
  let t12;
  if ($[19] !== account.address || $[20] !== capacitor.isIos || $[21] !== country || $[22] !== owner || $[23] !== ownerENS || $[24] !== profile?.handle || $[25] !== props.collection.artist || $[26] !== props.collection.artist_address || $[27] !== props.collection.name || $[28] !== props.collection.on_chain || $[29] !== props.token_id || $[30] !== tokenImage || $[31] !== tokenMetadataUrl || $[32] !== tokenName) {
    t12 = function printToken() {
      return <><Container fluid={true} className={`${styles.tokenContainer} pt-4 pb-4`}><Row><Col><Container><Row><Col className="d-flex align-items-center justify-content-between"><h2 className="mb-0">{tokenName}</h2></Col></Row><Row className="pt-4"><Col className="text-center"><Image unoptimized={true} priority={true} loading="eager" width="0" height="0" style={{
                      height: "auto",
                      width: "auto",
                      maxHeight: "90vh",
                      maxWidth: "100%"
                    }} src={tokenImage} alt={tokenName} /></Col></Row></Container></Col></Row></Container><Container className="pt-3 pb-3"><Row><Col><h4>About</h4></Col></Row><Row><Col className="d-flex align-items-center gap-5"><span className="pt-1 pb-1 d-flex flex-column"><span className="font-color-h">Token ID</span><span>#{props.token_id}</span></span><span className="pt-1 pb-1 d-flex flex-column"><span className="font-color-h">Collection</span><Link href={`/nextgen/collection/${formatNameForUrl(props.collection.name)}`}>{props.collection.name}</Link></span><span className="pt-1 pb-1 d-flex flex-column"><span className="font-color-h">Artist</span><Link href={`/${props.collection.artist_address}`}>{props.collection.artist}</Link></span><span className="pt-1 pb-1 d-flex flex-column"><span className="font-color-h">Owner</span><span className="d-flex"><Address wallets={[owner as `0x${string}`]} display={profile?.handle ?? ownerENS} />{areEqualAddresses(owner, account.address) && <span>(you)</span>}</span></span><span className="pt-1 pb-1 d-flex flex-column"><span className="font-color-h">Metadata</span><span className="d-flex align-items-center gap-1"><span>{props.collection.on_chain ? "On-Chain" : "Off-Chain"}{" "}<Link href={tokenMetadataUrl} target="_blank" rel="noopener noreferrer"><FontAwesomeIcon className={styles.copyIcon} icon={faExternalLinkSquare} /></Link></span></span></span>{(!capacitor.isIos || country === "US") && <span className="pt-1 pb-1 d-flex flex-column"><span className="font-color-h">Marketplaces</span><span className="d-flex gap-4"><><Link href={getOpenseaLink(NEXTGEN_CHAIN_ID, props.token_id)} target="_blank" rel="noopener noreferrer" data-tooltip-id={`opensea-${props.token_id}`}><Image unoptimized={true} className={styles.marketplace} src="/opensea.png" alt="opensea" width={28} height={28} /></Link><Tooltip id={`opensea-${props.token_id}`} content="Opensea" delayShow={250} style={{
                      backgroundColor: "#1F2937",
                      color: "white",
                      padding: "4px 8px"
                    }} /></></span></span>}</Col></Row><Row className="pt-3"><Col><b>Token Indexing, check back later <DotLoader /></b></Col></Row></Container></>;
    };
    $[19] = account.address;
    $[20] = capacitor.isIos;
    $[21] = country;
    $[22] = owner;
    $[23] = ownerENS;
    $[24] = profile?.handle;
    $[25] = props.collection.artist;
    $[26] = props.collection.artist_address;
    $[27] = props.collection.name;
    $[28] = props.collection.on_chain;
    $[29] = props.token_id;
    $[30] = tokenImage;
    $[31] = tokenMetadataUrl;
    $[32] = tokenName;
    $[33] = t12;
  } else {
    t12 = $[33];
  }
  const printToken = t12;
  if (fetchingMetadata || tokenNotFound || !tokenImage) {
    let t13;
    if ($[34] !== tokenNotFound) {
      t13 = <Container className="pt-5"><Row><Col className="text-center"><h4 className="mb-0">{tokenNotFound ? <>Token Not Found</> : <>Fetching Token <DotLoader /></>}</h4></Col></Row></Container>;
      $[34] = tokenNotFound;
      $[35] = t13;
    } else {
      t13 = $[35];
    }
    return t13;
  }
  let t13;
  if ($[36] !== printToken) {
    t13 = printToken();
    $[36] = printToken;
    $[37] = t13;
  } else {
    t13 = $[37];
  }
  return t13;
}